import { accessDBApi } from './api';
import type { ConversationAnalyticsData } from '../types';

export interface ChatUsageDataPoint {
  date: string;
  count: number;
}

export interface ChatUsageTrend {
  value: number;
  label: string;
}

export interface ChatUsageResponse {
  period: string;
  days: number;
  data_points: ChatUsageDataPoint[];
  total: number;
  trend: ChatUsageTrend | null;
}

export const analyticsService = {
  getChatUsage: async (period: string = 'daily', days: number = 30) => {
    const response = await accessDBApi.get<{ success: boolean; data: ChatUsageResponse }>(
      `/analytics/chat-usage?period=${period}&days=${days}`
    );
    return response.data;
  },

  getConversationAnalytics: async (
    domainId: string,
    fromDate: string,
    toDate: string,
  ): Promise<{ success: boolean; data: ConversationAnalyticsData }> => {
    const response = await accessDBApi.get(
      `/analytics/conversation/${domainId}`,
      { params: { from_date: fromDate, to_date: toDate } },
    );
    return response.data;
  },
};
